import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { firebase } from '../../core/services'

import {
  ANALYTICS_EVENT_CATEGORIES,
  ANALYTICS_EVENTS,
} from '../../common/constants'
import { apolloService } from '../../common/services'

import { RETRY_MENU_TITLE_LABELS_AND_INGREDIENTS_MUTATION } from '../graphql/mutations'
import { RETRY_MENU_TITLE_LABELS_AND_INGREDIENTS } from '../redux/action-types'

const useRetryMenuTitleLabelsAndIngredientsMutation = () => {
  const dispatch = useDispatch()

  const { isUpdateLoading: isLoading, updateError: error } = useSelector(
    store => store.menuCurationTasks.menuCurationTask,
  )

  const mutate = useCallback(
    menuTitle => {
      firebase.logEvent(
        ANALYTICS_EVENTS.MENU_CURATOR_UPDATE_MENU_TASK
          .MENU_CURATOR_RETRY_MENU_TITLE_LABELS_INGREDIENTS,
        {
          menuTitleId: menuTitle.id,
          menuId: menuTitle.menuId,
          eventCategory:
            ANALYTICS_EVENT_CATEGORIES.MENU_CURATOR_UPDATE_MENU_TASK,
        },
      )

      return apolloService.mutate({
        mutation: RETRY_MENU_TITLE_LABELS_AND_INGREDIENTS_MUTATION,
        variables: { id: menuTitle.id },
        dispatch,
        action: RETRY_MENU_TITLE_LABELS_AND_INGREDIENTS,
      })
    },
    [dispatch],
  )

  return [mutate, { isLoading, error }]
}

export default useRetryMenuTitleLabelsAndIngredientsMutation
